import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PRIVATE_API } from "../../api/apiIndex";

const initialState = {
  data: [],
  error: "",
  status: "idle",
  resultData: null,
  resultStatus: "idle",
  resultError: "",
};

export const getHistory = createAsyncThunk(
  "history/getHistory",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.get(`/submit/user/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error);
    }
  }
);

export const getAResult = createAsyncThunk(
  "history/getAResult",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PRIVATE_API.get(`/submit/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error);
    }
  }
);

const historySlice = createSlice({
  name: "history",
  initialState,
  reducers: {
    clearResult: (state) => {
      state.resultData = null;
      state.resultError = "";
      state.resultStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHistory.pending, (state, action) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(getHistory.fulfilled, (state, action) => {
        state.status = "success";
        state.error = "";
        state.data = action.payload.data;
        // console.log(action);
      })
      .addCase(getHistory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload.message;
      })
      .addCase(getAResult.pending, (state, action) => {
        state.resultStatus = "loading";
        state.resultError = "";
      })
      .addCase(getAResult.fulfilled, (state, action) => {
        state.resultStatus = "success";
        state.resultError = "";
        state.resultData = action.payload.data;
        // console.log(action);
      })
      .addCase(getAResult.rejected, (state, action) => {
        state.resultStatus = "failed";
        state.resultError = action.payload.message;
      });
  },
});

export const { clearResult } = historySlice.actions;

export const getHistoryData = (state) => state.history.data;
export const getHistoryStatus = (state) => state.history.status;
export const gethistoryError = (state) => state.history.error;

export const getResultHistoryData = (state) => state.history.resultData;
export const getResultHistoryStatus = (state) => state.history.resultStatus;
export const getResulthistoryError = (state) => state.history.resultError;

export default historySlice.reducer;
